import LinkGrid, { LinkGridProps } from '@/components/_organisms/LinkGrid';
import { GlobalsCapabilitiesPagesFragment, Maybe } from '@/graphql';
import { getSingleLink } from '@/lib/craft-utils';
import { notEmpty } from '@/lib/typescript-helpers';
import { FC } from 'react';

export interface CapabilitiesLinkGridModuleProps {
  links?: Maybe<GlobalsCapabilitiesPagesFragment>;
}

const CapabilitiesLinkGridModule: FC<CapabilitiesLinkGridModuleProps> = ({ links }) => {
  if (!links) return null;

  return (
    <LinkGrid
      groups={
        links.groups
          .filter(notEmpty)
          .map((group) => {
            if (!group.heading) return null;

            const cta = getSingleLink(group.cta);

            return {
              heading: group.heading,
              cta: cta
                ? {
                  text: cta.text,
                  href: cta.url,
                }
                : undefined,
              links:
                group.links
                  .filter(notEmpty)
                  .map((link) => {
                    if (!link.entry || !link.description) return null;

                    const entry = getSingleLink(link.entry);

                    if (!entry || !entry.text) return null;

                    return {
                      title: entry.text,
                      href: entry.url,
                      description: link.description,
                    };
                  })
                  .filter(notEmpty) ?? [],
            } satisfies LinkGridProps['groups'][0];
          })
          .filter(notEmpty) ?? []
      }
    />
  );
};

export default CapabilitiesLinkGridModule;
